<template>
  <PieChart ref="proceedsChartRef" :chartData="pieChartData" :options="pieOptions" />
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue'
import { PieChart } from 'vue-chart-3'
import { Chart, registerables } from 'chart.js'
import { pieChartOptionsVar } from '../inc/proceedsChart.js'

Chart.register(...registerables)

export default defineComponent({
  name: 'ProceedsChart',
  props: {
    proceedsChartData: Object
  },
  components: { PieChart },
  setup (props) {
    const proceedsChartRef = ref()
    const pieOptions = pieChartOptionsVar
    const pieChartData = {
      labels: props.proceedsChartData.labels,
      datasets: [
        {
          type: 'pie',
          data: props.proceedsChartData.data,
          backgroundColor: props.proceedsChartData.colors,
          borderColor: props.proceedsChartData.borders,
          borderWidth: 2
        }

      ]
    }
    onMounted(() => {
      proceedsChartRef.value.chartInstance.resize()
    })

    return { pieChartData, pieOptions, proceedsChartRef }
  },
  created () {
    globalThis.addEventListener('resize', this.resizeCharts)
  },
  unMounted () {
    globalThis.removeEventListener('resize', this.resizeCharts)
  },
  methods: {
    resizeCharts (e) {
      this.$refs.proceedsChartRef.chartInstance.resize()
    }
  }
})

</script>
